<template>
  <nna-container :spacing=10 bottom-bar-active>
    <products-filter :data="filter" @onFilter="_onFilter" class="p-3" />
      <div class="products">
      <product
        v-for="product in products"
        v-show="product.visible"
        :key="product.oid"
        :data="product"
      />
      </div>
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import productsFilter from '@/modules/common/components/products/productsFilter'
import product from '@/modules/common/components/products/product.vue'
import _ from 'lodash'
export default {
  name: 'Products',
  components: {
    productsFilter,
    product
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      shop: 'shops/current',
      products: 'shops/products',
    }),
    filter() {
      return this.shop && this.shop.productCategories ? this.shop.productCategories : {}
    }    
  },
  methods: {
    ...mapActions({      
    }),
    _onFilter(filter) {
      filter.map(item => this.$store.commit("shops/PRODUCTS_FILTER", item))
    }    
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/Shop/pages/Products.vue